import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { ProfileQuicksearchComponent } from '../../../../../../profiles/profile-quicksearch/profile-quicksearch.component';
import { InvoiceService } from '../../../../../../revenue/shared/invoice/invoice.service';
import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';
import { InvoiceAdvancedSearch } from '../../../../../../revenue/shared/invoice/invoice-advanced-search.model';
import { NotificationService, UtilService, TranslationService } from 'src/app/shared';
import { MultiInvoicePaymentComponent } from '../../../../../../revenue/multi-invoice-payment/multi-invoice-payment.component';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { PagedResultGeneric } from 'src/app/shared/model';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import { AgingPeriodEnum } from 'src/app/revenue/shared/invoice/aging-period.model';

@Component({
  selector: 'wl-batch-payment-dialog',
  templateUrl: './batch-payment-dialog.component.html',
  styleUrls: ['./batch-payment-dialog.component.less'],
    standalone: false
})
export class BatchPaymentDialogComponent implements OnInit {
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    if (value && this._multiInvoicePaymentComponent) {
      this._multiInvoicePaymentComponent.newBatch();
    }
    this.showChange.emit(this._show);
  }
  @ViewChild(MultiInvoicePaymentComponent) private _multiInvoicePaymentComponent: MultiInvoicePaymentComponent;
  @ViewChild(ProfileQuicksearchComponent) private _quicksearchComponent: ProfileQuicksearchComponent;

  isSaving = false;
  loadingProfileInvoices = false;
  profileResults: PagedResultGeneric<ProfileMin>;
  selectedProfile: ProfileMin;
  invoiceNumbers: number[];

  private _show: boolean;

  constructor(
    private _notificationService: NotificationService,
    private _utilService: UtilService,
    private _translationService: TranslationService,
    private _invoiceService: InvoiceService,
    private _profileService: ProfileService
  ) {}

  ngOnInit() {}

  keywordChanged(keyword: string) {
    if (!this._utilService.isNumeric(keyword)) {
      this._quicksearchComponent.search();
    }
  }

  setResults(profileResults: PagedResultGeneric<ProfileMin>) {
    this.profileResults = profileResults;
  }

  profileSelected(profile: ProfileMin) {
    this.loadingProfileInvoices = true;
    this.selectedProfile = profile;
    const searchParams = new InvoiceAdvancedSearch();
    const profileExpression = new SerialSearchExpression();
    profileExpression.Field = 'ProfileID';
    profileExpression.Value = profile.ProfileId.toString();
    searchParams.InvoiceInfoSearchExpressions.push(profileExpression);
    searchParams.AgingPeriod = AgingPeriodEnum.AllOpen;
    searchParams.PageSize = 999;
    this._invoiceService.advancedSearch(searchParams).then((searchResult) => {
      this.invoiceNumbers = searchResult.Result.map((x) => x.InvoiceNum);
      this.loadingProfileInvoices = false;
    });
  }

  enterPressed(keywordValue: string) {
    if (!this._utilService.isNumeric(keywordValue)) {
      const message = this._translationService.getInstant(
        'shared.container.toolbars.module.revenue.batch-payment-dialog.non-numeric-invoice-error'
      );
      this._notificationService.error(message);
    } else {
      const invoiceNumber = parseInt(keywordValue, 10);
      this.invoiceNumbers = [invoiceNumber];
    }
  }

  save(addNew = false) {
    this.isSaving = true;
    this._multiInvoicePaymentComponent.applyPayments().then(
      (paymentsResult) => {
        this.isSaving = false;
        for (const message of paymentsResult.messages) {
          this._notificationService.success(message);
        }
        if (!addNew) {
          this.show = false;
          this.resetData();
        }
        this.resetData(['_paymentType', 'PaymentType', 'PaymentTypeID']);
      },
      (paymentsResult) => {
        this.isSaving = false;
        for (const message of paymentsResult.messages) {
          this._notificationService.error(message);
        }
      }
    );
  }

  cancelClicked() {
    this.resetData();
    this.show = false;
  }

  private resetData(fieldsToPreserve: string[] = []) {
    this.invoiceNumbers = null;
    this.selectedProfile = null;
    this._multiInvoicePaymentComponent.resetData(fieldsToPreserve);
  }

  loadInvoiceProfile(profileId: number) {
    this._profileService.getProfileMin(profileId).then((data: ProfileMin) => {
      this.selectedProfile = data;
    });
  }
}
